import { UAParser } from "ua-parser-js";

export const getUserAgentDetails = () => {
  const parser = new UAParser();
  return {
    browser: parser.getBrowser(),
    engine: parser.getEngine(),
    os: parser.getOS(),
    device: parser.getDevice(),
    cpu: parser.getCPU(),
  };
};

export const isAppleDevice = (): boolean => {
  const parser = new UAParser();
  const deviceType = parser.getDevice().model || "";
  // Check if device model or OS or platform indicates Apple device
  const result = /iPad|iPhone|iPod/.test(deviceType);
  return result;
};
